import styled from 'styled-components';
import {media, tokens} from "../../../theme";


export const CitationsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    width: 100%;
`;

export const CitationsTitle = styled.div`
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.semibold};
    color:  ${({theme}) => theme.palette.text.primary};
    margin-bottom: 4px;

    ${media.sm} {
        font-size: ${tokens.fontSize.sm};
    }
`;

export const CitationCard = styled.div`
    background: ${({theme}) => theme.palette.message.assistantTextBg};
    border-left: 3px solid  ${({theme}) => theme.palette.primary.main};
    border-radius: ${tokens.radius.sm};
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    ${media.sm} {
        padding: 14px;
    }
`;

export const CitationContent = styled.div`
    font-size: ${tokens.fontSize.xs};
    color: ${({theme}) => theme.palette.text.primary};
    line-height: 1.5;
    word-break: break-word;
    white-space: pre-wrap;

    ${media.sm} {
        font-size: ${tokens.fontSize.sm};
    }
`;

export const CitationSource = styled.div`
    font-size: ${tokens.fontSize.xs};
    color: ${({theme}) => theme.palette.text.primary};
    margin-bottom: 4px;

    ${media.sm} {
        font-size: ${tokens.fontSize.sm};
    }
`;

export const CitationButtonsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
    width: 100%;
`;

export const CitationButton = styled.button<{ $isActive?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: ${tokens.radius.lg};
    height: 32px;
    min-height: 32px;
    padding: 0 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.semibold};
    
    background: ${({ $isActive, theme}) => $isActive 
            ? theme.palette.primary.main : theme.palette.message.assistantTextBg};
    color: ${({ $isActive, theme}) => $isActive
            ? theme.palette.primary.contrastText : theme.palette.text.primary};
    border: 1px solid ${({ $isActive, theme}) => $isActive
            ? theme.palette.primary.main : theme.palette.message.assistantTextBg};
    
    white-space: nowrap;

    i {
        font-size: ${tokens.fontSize.xs};
    }

    &:hover {
        background: ${({ $isActive, theme}) => $isActive
                ? theme.palette.primary.dark : theme.palette.action.hoveredBackground};
        
        border-color: ${({ $isActive, theme}) => $isActive
                ? theme.palette.primary.dark : theme.palette.dividers.subtle};
    }

    &:active {
        background: ${({ $isActive, theme}) => $isActive
                ? theme.palette.primary.main : theme.palette.message.assistantTextBg};
    }

    ${media.sm} {
        font-size: ${tokens.fontSize.sm};
        padding: 0 16px;

        i {
            font-size: ${tokens.fontSize.xs};
        }
    }
`;
